"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playTutorialMovesAction = exports.PLAY_TUTORIAL_MOVES = void 0;
exports.PLAY_TUTORIAL_MOVES = 'PLAY_TUTORIAL_MOVES';
var playTutorialMovesAction = function (quantity) { return ({ type: exports.PLAY_TUTORIAL_MOVES, quantity: quantity }); };
exports.playTutorialMovesAction = playTutorialMovesAction;
